import moment from 'moment';
/* import HTTPClient from './http-client';

const END_POINT = 'data_layers.json';
const options = {
    cache: {
        maxAge: 24 * 60 * 1000,
        exclude: { query: false }
    }
}; */

const loadSuppliedInhabitants =  async (period, type) => {
    const data = [];
    let initDate;
    let finalDate;
    const stringDateFormat = type === 'Diário' ? 'YYYY-MM-DD' : 'YYYY-MM';
    
    if(moment(period[0]).isBefore(moment(period[1]))){
        initDate =  moment(period[0])
        finalDate = moment(period[1]);
    }else{
        initDate = moment(period[1]);
        finalDate = moment(period[0]);
    }

    while (initDate.isSameOrBefore(finalDate)) {
        data.push(
            {
                date: initDate.format(stringDateFormat),
                value: Math.floor(Math.random() * 40) + 1
            }
        );
        
        initDate = initDate.add(1, type === 'Diário' ? 'days': 'months');
    }

    return {data};
}


const loadUnSuppliedInhabitants =  async (period, type) => {
    const data = [];
    let initDate;
    let finalDate;
    const stringDateFormat = type === 'Diário' ? 'YYYY-MM-DD' : 'YYYY-MM';
    
    if(moment(period[0]).isBefore(moment(period[1]))){
        initDate =  moment(period[0])
        finalDate = moment(period[1]);
    }else{
        initDate = moment(period[1]);
        finalDate = moment(period[0]);
    }

    while (initDate.isSameOrBefore(finalDate)) {
        data.push(
            {
                date: initDate.format(stringDateFormat),
                value: Math.floor(Math.random() * 40) + 1
            }
        );
        
        initDate = initDate.add(1, type === 'Diário' ? 'days': 'months');
    }

    return {data};
}


export {
    loadSuppliedInhabitants,
    loadUnSuppliedInhabitants
}